import { useApolloClient } from '@apollo/client';
import { dayFormatType, formatDay, moment } from '~helpers/day';
import { QUERY_PARTNER_CONTACTS } from '~pages/dashboard/referral/partner/queries';
import { message } from 'antd';
import exportToCsv from '~helpers/export-csv';
import { get } from 'lodash';
import { useCallback, useState } from 'react';

export default function useExportPartner() {
  const client = useApolloClient();
  const [isLoading, setIsLoading] = useState(false);

  const handleExportCSV = useCallback(async ({ queryFilter, totalCount = 999 }) => {
    try {
      setIsLoading(true);
      const queryResponse = await client.query({
        query: QUERY_PARTNER_CONTACTS,
        variables: {
          pageNumber: 1,
          pageSize: totalCount,
          sortBy: 'UPDATED_AT',
          partnerType: 'INDIVIDUAL',
          sortDirection: 'DESCENDING',
          partnerName: queryFilter.partnerName || null,
          partnerCode: queryFilter.partnerCode || null,
          partnerReferrerId: queryFilter.referrerId || null,
          phoneNumber: queryFilter.phoneNumber || null,
          createdAfter: queryFilter.createdTime.length ? queryFilter.createdTime[0] : null,
          createdBefore: queryFilter.createdTime.length ? queryFilter.createdTime[1] : null,
        },
        fetchPolicy: 'no-cache',
      });

      const allListData = queryResponse?.data?.partnerContacts?.edges.map(edge => edge.node) || [];
      const csvData = allListData.map(item => {
        const csvColumns = [];
        [
          'partner.name',
          'phoneNumber',
          'partner.originCountry.name',
          'partner.code',
          'partner.commissionPlan.name',
          'partner.payoutPlan.name',
          {
            key: 'partner.internalReferrer',
            transfer: record => `${record?.firstName || ''} ${record?.lastName || ''}`,
          },
          {
            key: 'createdAt',
            transfer: record => `\t${formatDay(dayFormatType.UKWITHHM, record)}\t`,
          },
        ].map(dataKey => {
          if (typeof dataKey === 'string') {
            csvColumns.push(get(item, dataKey) || '');
          } else {
            csvColumns.push(dataKey.transfer(get(item, dataKey.key)));
          }
        });
        return csvColumns;
      });

      exportToCsv(`[Student.com][Partner]-${moment().format(dayFormatType.UKWITHHM)}.csv`, [
        [
          'Partner Name',
          'Phone Number',
          'Country',
          'Partner Code',
          'CommissionPlan Name',
          'Payout Name',
          'Referrer Name',
          'Signup Date',
        ],
        ...csvData,
      ]);
      setIsLoading(false);
    } catch (e) {
      message.error(e?.toString());
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { exportToCSV: handleExportCSV, isLoading };
}
